export const filtersData = ["Redux", "HTML/CSS", "React", "All"];
